import jQuery from 'jquery';
import Reveal from 'reveal.js';

import 'reveal.js/css/reveal.scss';

// replace this file with your customized theme:
import '../styles/cdct-theme.scss';

// Needed for Reveal
import 'reveal.js/lib/js/head.min';
// import 'reveal.js/lib/js/classList';

jQuery(() => {

    window.Reveal = Reveal;

    require('reveal.js/plugin/notes/notes');
    require('reveal.js/plugin/zoom-js/zoom');
    require('reveal.js/plugin/markdown/marked');
    require('reveal.js/plugin/markdown/markdown');
    require('highlight.js/lib/highlight');

    Reveal.initialize({
        controls: true,
        progress: true,
        history: true,
        center: true,
        
        // The "normal" size of the presentation, aspect ratio will be preserved
        // when the presentation is scaled to fit different resolutions
        width: 1280,
        height: 800,

        // Factor of the display size that should remain empty around the content
        margin: 0.04,

        // Optional libraries used to extend on reveal.js
        // dependencies: []
    });
    
});
